import styled from "styled-components";
import AboutUs from "../components/AboutUs";
import FeedbackSection from "../components/FeedbackSection";
import RelocationForm from "../components/companies/RelocationForm";
import Banner from "../components/home/banner";
import Benefits from "../components/home/Benefits";
import Process from "../components/home/Process";
import Premium from "../components/home/Premium";

// Estilo do contêiner principal da home
const HomeContainer = styled.div`
  padding: 20px;
  background-color: #f5f5f5;
`;

const Home = () => (
  <HomeContainer>
    <Banner />
    <Benefits/>
    <Process />
    <Premium />
    <FeedbackSection />
    <RelocationForm />    
    <AboutUs />
  </HomeContainer>
);

export default Home;
